import { ChevronRightIcon } from '@heroicons/react/outline';
import Link from 'next/link';
import { PATH } from 'Lib/constants/path';

export default function AddAddressSection() {
  return (
    <Link href={PATH.ADD_ADDRESS}>
      <a className="add-address-section">
        <span>Thêm địa chỉ mới</span>
        <ChevronRightIcon className="h-6 w-6" />
      </a>
    </Link>
  );
}
